module.exports = __webpack_public_path__ + "img/ppt.42ccdd1e.png";